/* ==========================================================================
   BOUNTEOUS CONFIDENTIAL
   ___________________

   Copyright 2019 Bounteous
   All Rights Reserved.

   NOTICE:  All information contained herein is, and remains the property
   of Bounteous and its suppliers, if any. The intellectual and
   technical concepts contained herein are proprietary to Bounteous
   and its suppliers and are protected by trade secret or copyright law.
   Dissemination of this information or reproduction of this material
   is strictly forbidden unless prior written permission is obtained
   from Bounteous.
   ========================================================================== */

import { Component, registerComponent } from 'js/component.js';
import { isMobileOrTablet } from 'js/helpers.js';

const componentName = 'cmp-video-external';
const YOUTUBE_SOURCE = 'youtube';
const VIMEO_SOURCE = 'vimeo';

export class VideoExternal extends Component {

    /**
     * Remove Overlay on Mobile/Tablet
     */
    checkMobile() {
        if(isMobileOrTablet() && this.overlay !== null) {
            this.elements.overlay.style.display = 'none';
        }
    }

    /**
     * Set Up Video Elements
     */
    setupElements() {
        if (this.elements.overlay === null) {
            this.elements.inner.setAttribute('style', 'display:block');
        } else {
            this.addEventListeners();
        }
    }

    /**
     * Add Event Listeners
     */
    addEventListeners() {
        const classScope = this;

        // On Video Click (Overlay)
        function onVideoClick(e) {
            e.preventDefault();
            classScope.elements.overlay.setAttribute('style', 'display:none');
            classScope.elements.inner.setAttribute('style', 'display:block');

            if (classScope.source === YOUTUBE_SOURCE) {
                const iframeSrc = classScope.elements.iframe.src;

                if(classScope.elements.iframe.src.indexOf('autoplay=0' > -1)) {
                    classScope.elements.iframe.src = iframeSrc.replace('autoplay=0', 'autoplay=1');
                } else {
                    classScope.elements.iframe.src = `${iframeSrc}&autoplay=1`;
                }
            } else if (classScope.source === VIMEO_SOURCE) {
                classScope.elements.iframe.contentWindow.postMessage('{"method": "play"}', '*');
            }
        }

        // Assign Listeners
        this.elements.playButton.addEventListener('click', onVideoClick);
    }

    /**
     * Initialize Component
     */
    init() {
        // Set Up Elements
        this.elements = {
            overlay: this.element.querySelector(`.${componentName}__overlay`),
            playButton: this.element.querySelector(`.${componentName}__play-button`),
            inner: this.element.querySelector(`.${componentName}__inner`),
            iframe: this.element.querySelector('iframe'),
        };

        // Set Up Data
        this.source = this.element.dataset.videoSource;

        // Fire Init Funcs
        this.setupElements();
        this.checkMobile();
    }
}

registerComponent(`.${componentName}`, VideoExternal);
